import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createKmdEasyFilesDetailViewRoutesMap } from './id'

export const createKmdEasyFilesRoutesMap = (prefix: string) => ({
  'fu63303/:id': (id = ':id') =>
    pathJoin(prefix)('fu63303')(id).chainMapAuto(
      createKmdEasyFilesDetailViewRoutesMap,
      {
        title: <T _str="KMD Easy file rows" />,
        breadCrumbTitle: <T _str="KMD Easy file rows" />,
      }
    ),
  'fu63302/:id': (id = ':id') =>
    pathJoin(prefix)('fu63302')(id).chainMapAuto(
      createKmdEasyFilesDetailViewRoutesMap,
      {
        title: <T _str="KMD Easy file rows" />,
        breadCrumbTitle: <T _str="KMD Easy file rows" />,
      }
    ),
})
